export enum NotificationType {
  WEB_LOGIN_LINK = "WEB_LOGIN_LINK",
  WEB_RESET_PASSWORD_LINK = "WEB_RESET_PASSWORD_LINK",
}

export interface NotificationPayload {
  delivery_type: "EMAIL"
  recipients: {
    user_ids: string[]
    broadcast: boolean
  }
  type: NotificationType
  data: Record<string, unknown>
}
